// Which item types the scanner serves (phase 4 §5): those with an ISBN or an
// EAN field in use. Small on purpose: the shell and the collection page read
// it, the scanner itself is loaded only on its page.

/** The key of the type's field that holds a code of this scheme: an ISBN in an ISBN field, else in an EAN field. */
export const codeFieldKey = (type, scheme) => {
  const fields = ((type && type.fields) || []).filter(field => field.type === 'identifier' && !field.unused);
  const of = (wanted) => (fields.find(field => (field.scheme || 'other') === wanted) || {}).key || null;
  return scheme === 'isbn' ? (of('isbn') || of('ean')) : of(scheme);
};

/** True for a type the scanner can fill (an ISBN or an EAN field). */
export const isScannable = (type) => !!(codeFieldKey(type, 'isbn') || codeFieldKey(type, 'ean'));

/** The collection's types the scanner serves, its default first. */
export const scannableTypes = (inventory) => {
  const types = ((inventory && inventory.item_types) || []).filter(isScannable);
  const preferred = inventory && inventory.default_item_type ? inventory.default_item_type.id : null;
  return [...types].sort((a, b) => Number(b.id === preferred) - Number(a.id === preferred));
};

/** The scanner's address for a collection (and a type). */
export const scanPath = (inventoryId, typeId) => `/c/${inventoryId}/scan${typeId ? `?type=${typeId}` : ''}`;
